import { useState } from "react";

const faqItems = [
  {
    question: "Is a Superbuy Spreadsheet safe to use?",
    answer: "Yes, a Superbuy Spreadsheet is safe when you use it from trusted resources and follow recommended safety practices. The spreadsheet itself is simply an organizational tool that compiles product links and information. The safety depends on the sources of the product links and the platform you use for purchasing. Always verify sellers and use secure payment methods.",
  },
  {
    question: "How do beginners start using a Superbuy Spreadsheet?",
    answer: "Beginners should start by reading comprehensive guides on this website, then explore a well-organized spreadsheet category by category. Focus on understanding the layout, learning to compare sellers, and starting with small purchases to build confidence. Our beginner guides walk you through each step of the process.",
  },
  {
    question: "What is QC in Superbuy?",
    answer: "QC stands for Quality Control. It refers to the detailed photos taken of your products when they arrive at the warehouse. These photos allow you to inspect items for defects, verify sizing against measurement charts, and ensure the product matches the listing description before you pay for international shipping.",
  },
  {
    question: "How often are Superbuy Spreadsheets updated?",
    answer: "Quality superbuy spreadsheets are typically updated weekly or bi-weekly. Product availability, pricing, and seller information can change frequently, so it is important to use the most current version. Always check for the latest spreadsheet updates before placing orders.",
  },
  {
    question: "Can I use a Superbuy Spreadsheet on my mobile phone?",
    answer: "Yes, most superbuy spreadsheets are fully compatible with mobile spreadsheet applications like Google Sheets and Microsoft Excel mobile. You can browse, sort, and access product links directly from your smartphone, making it convenient to shop on the go.",
  },
  {
    question: "What shipping method should I choose?",
    answer: "The best shipping method depends on your priorities. DHL Express is fastest (3-7 days) but most expensive. EMS offers a good balance (7-15 days) at medium cost. Air Cargo and Sea Freight are cheaper but much slower. Consider your budget, timeline, and package weight when deciding.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          Frequently Asked <span className="text-accent-600">Questions</span>
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          Common questions about using superbuy spreadsheets
        </p>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="border border-background-200/70 rounded-xl overflow-hidden bg-background-50"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 text-foreground-400 ${
                    openIndex === i ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* FAQ Schema JSON-LD */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": faqItems.map((item) => ({
                "@type": "Question",
                "name": item.question,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}